import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchData } from '../../hooks/fetchData';

///
export const fetchDailyScoreThunk = createAsyncThunk(
  'scores/fetchDailyScore',
  async ({id, skip, limit}, thunkAPI) => {
    try {
      const response = await fetchData(`/profiles/score/${id}?skip=${skip}&limit=${limit}`, 'get', {});
      return response.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err);
    }
  }
);
///

export const getScoresHistoryThunk = createAsyncThunk(
  'scores/data',
  async ({ userId, skip }, thunkAPI) => {
    try {
      const response = await fetchData(`scoreHistory/${userId}?skip=${skip}`, 'get', {});
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);

export const getScoreDetailsThunk = createAsyncThunk(
  'score/details',
  async ({ userId, profileId, date }, thunkAPI) => {
    try {
      const response = await fetchData(`scoreDetails/${userId}?profileId=${profileId}&date=${date}`, 'get', {});
      return thunkAPI.fulfillWithValue(response.data);
    } catch (err) {
      return thunkAPI.rejectWithValue();
    }
  },
);
export const scoresSlice = createSlice({
  name: 'scoresHistory',
  initialState: {
    data: [],
    dailyScore: [],
    scoreDetails: {}
  },
  extraReducers: (builder) => {
    builder
      //.addCase(getScoresHistoryThunk.fulfilled, (state, action) => {
      //  state.data = action.payload;
      //})
      .addCase(getScoresHistoryThunk.fulfilled, (state, action) => {
        const skip = action.meta.arg.skip;
      
        state.data =
          skip === 0
            ? action.payload
            : [...state.data, ...action.payload];
      })
      .addCase(getScoreDetailsThunk.fulfilled, (state, action) => {
        state.scoreDetails = action.payload;

      })
      .addCase(fetchDailyScoreThunk.fulfilled, (state, action) => {
        const skip = action.meta.arg.skip;
      
        state.dailyScore =
          skip === 0
            ? action.payload
            : [...state.dailyScore, ...action.payload];
      });
  },
});

export default scoresSlice.reducer;